/**
*
* MainTopics
*
*/

import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'react-bootstrap';
import useRecoveredData from 'utils/useRecoveredData.js';
import EditModal from './EditModal/index.jsx';
import StartConversation from './StartConversation.jsx';
import ListTopics from './ListTopics.jsx';
import Header from './Header.jsx';
import PendingTopics from './PendingTopics.jsx';
import messages from '../messages.js';
import useConversationsContext from '../useConversationsContext.js';

function MainTopics() {
  const { inbox, inboxId, topics, topicId } = useConversationsContext();
  const [storedMessage] = useRecoveredData('topics', inboxId, 'new');

  const [editPost, setEditPost] = useState(storedMessage);
  const { draft = 0, scheduled = 0 } = topics.pending || {};

  return (
    <>
      <Header />
      <div className="p-3 d-flex flex-column align-items-start">
        { inbox.archived
          ? <Badge bg="light" text="dark" className="mb-3"><FormattedMessage {...messages.archived} /></Badge>
          : <StartConversation setEditPost={setEditPost} /> }
        <PendingTopics pendingCount={draft + scheduled} setEditPost={setEditPost} />
      </div>
      <div className="flex-grow-1 overflow-auto">
        <ListTopics topics={topics} activeId={topicId} marginBottom={40} />
      </div>
      <EditModal show={Boolean(editPost)} post={editPost} onHide={() => setEditPost(null)} />
    </>
  );
}

export default MainTopics;
